import { render, staticRenderFns } from "./saveAsTemplateDialog.vue?vue&type=template&id=769e7442"
import script from "./saveAsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./saveAsTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports